import { createContextId } from '@builder.io/qwik';

export const SearchContext = createContextId<any>('docsearch');
